import React, {useState} from "react";
import {observer} from "mobx-react-lite";
import {useHistory, useLocation} from "react-router-dom";
import {useStore} from "../../../../../hooks/useStore";
import {AccountingRow} from "../../../../customer/customerHomePage/accountingRow/AccountingRow";
import {PanelLogo} from "../../../../_defaultComponents/PanelLogo/PanelLogo";
import {Link} from "react-router-dom";
import {
    Wrapper,
    TopSection,
    TopRightSection,
    BottomSection,
    LeftSection,
    RightSection,
    MenuButton,
    ButtonIcon,
    MobileMenuToggle,
    MobileMenu,
    CompanyInfo,
    MobileAccountSection
} from "./CustomerMenuHeader.styles";

// Icons
import deliveryIcon from "../../../../../public/images/delivery-icon.svg";
import accountingIcon from "../../../../../public/images/accounting-icon.svg";
import createDeliveryIcon from "../../../../../public/images/create-delivery-icon.svg";
import profileIcon from "../../../../../public/images/profile-icon.svg";
import logoutIcon from "../../../../../public/images/logout-icon.svg";
import {Img} from "components/company/companyDetail/companyDetailStyles";
import homeOutlinedIcon from "../../../../../public/images/home-outlined.svg";
import courierIcon from "../../../../../public/images/courier-icon.svg";

const DEFAULT_OPTIONS = {
    showLogo: true,
    showSideMenu: true,
    showLanguageSwitch: false
    // showWhatsappSupportButton: true
};

export const CustomerMenuHeader = observer(
    ({options = DEFAULT_OPTIONS, canShowCodPaymentMethodSelection}) => {
        const stores = useStore();
        const history = useHistory();
        const location = useLocation();
        const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
        const hasCourierDailyOperations = stores.meStore.hasCourierDailyOperations;
        const noWidthForRightSection =
            location.pathname === "/musteri" || location.pathname === "/musteri/hesabim";

        // canShowCodPaymentMethodSelection true ise cod sayfasında height 48px olsun
        const codOrAccounting = canShowCodPaymentMethodSelection
            ? false
            : location.pathname === "/musteri/kapida-odeme" ||
              location.pathname === "/musteri/muhasebe";

        const mainMenuItems = [
            {
                title: "Anasayfa",
                icon: homeOutlinedIcon,
                path: "/musteri",
                onClick: () => {
                    history.push("/musteri");
                    setIsMobileMenuOpen(false);
                }
            },
            {
                title: "Siparişlerim",
                icon: deliveryIcon,
                path: "/musteri/siparislerim",
                onClick: () => {
                    history.push("/musteri/siparislerim");
                    setIsMobileMenuOpen(false);
                }
            },
            {
                title: "Muhasebe",
                icon: accountingIcon,
                path: "/musteri/muhasebe",
                onClick: () => {
                    history.push("/musteri/muhasebe");
                    setIsMobileMenuOpen(false);
                }
            },
            {
                title: "Kapıda Ödeme",
                icon: createDeliveryIcon,
                path: "/musteri/kapida-odeme",
                onClick: () => {
                    history.push("/musteri/kapida-odeme");
                    setIsMobileMenuOpen(false);
                }
            },
            {
                title: "Yeni Teslimat",
                icon: createDeliveryIcon,
                path: "/musteri/manuel-gonderi-olustur",
                onClick: () => {
                    history.push("/musteri/manuel-gonderi-olustur");
                    setIsMobileMenuOpen(false);
                }
            },
            ...(hasCourierDailyOperations
                ? [
                      {
                          title: "Kurye İşlemleri",
                          icon: courierIcon,
                          path: "/musteri/kurye-gunluk-islemleri",
                          onClick: () => {
                              history.push("/musteri/kurye-gunluk-islemleri");
                              setIsMobileMenuOpen(false);
                          }
                      }
                  ]
                : [])
        ];

        const accountMenuItem = {
            title: "Hesabım",
            icon: profileIcon,
            path: "/musteri/hesabim",
            onClick: () => {
                history.push("/musteri/hesabim");
                setIsMobileMenuOpen(false);
            }
        };

        const toLogout = async () => {
            await stores.appStore.setLoading(true);
            await stores.meStore.logout();
            await history.push("/login");
            await stores.appStore.setLoading(false);
            setIsMobileMenuOpen(false);
        };

        const isActivePath = path => {
            return location.pathname === path;
        };

        const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
        };

        return (
            <Wrapper>
                {options.showLogo ? (
                    <TopSection>
                        <Link to={{pathname: "/musteri"}}>
                            <PanelLogo />
                        </Link>
                        <TopRightSection>
                            <CompanyInfo>
                                <Img
                                    className="desktop-only"
                                    src={stores?.meStore?.companies?.[0]?.photolink}
                                    data-testid="companyImage"
                                    style={{
                                        width: "35px",
                                        height: "35px",
                                        borderRadius: "50%",
                                        objectFit: "cover"
                                    }}
                                />
                                <div
                                    className="desktop-only"
                                    style={{
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.25)",
                                        borderRadius: "8px",
                                        padding: "8px 10px",
                                        backgroundColor: "#AEF001",
                                        fontSize: "14px",
                                        whiteSpace: "nowrap",
                                        border: "1px solid #AEF001",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    {stores?.meStore?.companies?.[0]?.companyName}
                                </div>
                                <MobileMenuToggle
                                    onClick={toggleMobileMenu}
                                    $isOpen={isMobileMenuOpen}
                                >
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </MobileMenuToggle>
                            </CompanyInfo>
                            <MenuButton
                                className="desktop-only"
                                onClick={accountMenuItem.onClick}
                                $isActive={isActivePath(accountMenuItem.path)}
                            >
                                <ButtonIcon
                                    src={accountMenuItem.icon}
                                    alt={accountMenuItem.title}
                                    $isActive={isActivePath(accountMenuItem.path)}
                                />
                                {accountMenuItem.title}
                            </MenuButton>
                            <MenuButton className="desktop-only" onClick={toLogout} $isLogout>
                                <ButtonIcon src={logoutIcon} alt="Çıkış Yap" />
                                Çıkış
                            </MenuButton>
                        </TopRightSection>
                    </TopSection>
                ) : (
                    <></>
                )}

                {/* Mobile Menu */}
                <MobileMenu $isOpen={isMobileMenuOpen}>
                    <MobileAccountSection>
                        <MenuButton
                            onClick={accountMenuItem.onClick}
                            $isActive={isActivePath(accountMenuItem.path)}
                            $isMobile
                        >
                            <ButtonIcon
                                src={accountMenuItem.icon}
                                alt={accountMenuItem.title}
                                $isActive={isActivePath(accountMenuItem.path)}
                            />
                            {accountMenuItem.title}
                        </MenuButton>
                        <MenuButton onClick={toLogout} $isLogout $isMobile>
                            <ButtonIcon src={logoutIcon} alt="Çıkış Yap" />
                            Çıkış
                        </MenuButton>
                    </MobileAccountSection>
                </MobileMenu>

                {/* Desktop Bottom Section */}
                <BottomSection>
                    <LeftSection>
                        {mainMenuItems.map((item, index) => (
                            <MenuButton
                                key={index}
                                onClick={item.onClick}
                                $isActive={isActivePath(item.path)}
                            >
                                <ButtonIcon
                                    src={item.icon}
                                    alt={item.title}
                                    $isActive={isActivePath(item.path)}
                                />
                                {item.title}
                            </MenuButton>
                        ))}
                    </LeftSection>
                    <RightSection
                        $noWidth={noWidthForRightSection}
                        $codOrAccounting={codOrAccounting}
                    >
                        <AccountingRow />
                    </RightSection>
                </BottomSection>
            </Wrapper>
        );
    }
);
